import { useRef, useState, useEffect, useCallback } from "react";
import { ExcelRenderer } from "react-excel-renderer";
import config from "../../config";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { TablePagination } from "@material-ui/core";
import {} from "papaparse";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import CustomTable from "../table";
import { Button as AntdButton, Card, Table, message } from "antd";
import { useCountry } from "../../provider/courtryProvider";
import { useNavigate } from "react-router-dom";
import { groupBy } from "lodash";
const UNIT = [
  "g",
  "kg",
  "mg",
  "ml",
  "L",
  "cup",
  "count",
  "box",
  "pkt",
  "glass",
  "cm",
  "m",
  "km",
  "min",
  "hour",
  "days",
  "inch",
  "ton",
];
function isNumeric(str) {
  return !isNaN(str) && !isNaN(parseFloat(str));
}

const expandedRowRender = (records) => {
  const columns = [
    {
      title: "Product Mrp",
      dataIndex: "productMrp",
      key: "productMrp",
    },
    {
      title: "Selling Price",
      dataIndex: "productPrice",
      key: "productPrice",
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (data) => {
        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor: data,
                width: 30,
                height: 30,
                borderRadius: "50%",
              }}
            />
          </div>
        );
      },
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",

      render: (data) => {
        return <div>{data ? data.toUpperCase() : "-"}</div>;
      },
    },
    {
      title: "Measurement",
      key: "measurement",

      render: (rowData) => {
        return (
          <div>
            <span>
              {(rowData.measurmentValue ? rowData.measurmentValue : "-") +
                " " +
                (rowData.measurmentUnit ? rowData.measurmentUnit : "-")}
            </span>
          </div>
        );
      },
    },
    {
      title: "Inventory Qty",
      dataIndex: "inventoryQty",
      key: "inventoryQty",
    },
    {
      title: "Purchase Price",
      dataIndex: "purchasePrice",
      key: "purchasePrice",
    },
    {
      title: "Product Code",
      dataIndex: "productCode",
      key: "productCode",
    },
    {
      title: "Product Ean",
      dataIndex: "productEANCode",
      key: "productEANCode",
    },
    {
      title: "Product HSN code",
      dataIndex: "productHsnCode",
      key: "productHsnCode",
    },
    {
      title: "Image",
      dataIndex: "productImageArray",
      key: "productImageArray",
    },
    {
      title: "Tax Id",
      dataIndex: "taxId",
      key: "taxId",
    },
    {
      title: "Inclusive/Exclusive",
      dataIndex: "taxIncExc",
      key: "taxIncExc",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={records.variantData}
      pagination={false}
      scroll={{ x: "max-content" }}
    />
  );
};

const ProductExcelUpload = (props) => {
  const shopDetails = useSelector((state) => state.shopDetails);
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const taxMaster = shopDetails.taxMaster;
  const navigate = useNavigate();

  const ref = useRef();
  const [dataArray, setDataArray] = useState([]);
  const [updatedShop, setUpdatedShop] = useState([]);
  const dispatch = useDispatch();
  const country = useCountry();
  const [excelData, setExcelData] = useState({
    individual: [],
    variant: [],
  });
  const [tableViewData, setTableViewData] = useState([]);

  const generateExcel = async () => {
    let taxNameArray = updatedShop.taxMaster?.map((value) => {
      return value.taxName;
    });

    let header = [
      "Category",
      "Sub Category",
      "Product Brand",
      "Product Name",
      "ProductMrp",
      "productPrice",
      "measurement Value",
      "measurement Unit",
      "inventoryQty",
      "productEANCode",
      "purchasePrice",
      "productCode",
      "productTax",
      "taxIncExc",
      "productHsnCode",
      "productImageArray",
    ];

    //Create workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Add Product Excel");

    worksheet.columns = [
      { header: "S No", key: "serialNo", width: 20 },
      { header: "Group", key: "group", width: 20 },
      { header: "Category", key: "category", width: 20 },
      { header: "Sub Category", key: "subCategory", width: 20 },
      { header: "Product Brand", key: "productBrand", width: 20 },
      { header: "Product Name", key: "productName", width: 20 },
      { header: "Product Mrp", key: "productMrp", width: 20 },
      { header: "Product Price", key: "productPrice", width: 20 },
      { header: "Color", key: "Color", width: 20 },
      { header: "Size", key: "Size", width: 20 },
      { header: "Measurement Value", key: "measurmentValue", width: 20 },
      { header: "Measurement Unit", key: "measurmentUnit", width: 20 },
      { header: "Inventory Qty", key: "inventoryQty", width: 20 },
      { header: "Product EAN Code", key: "productEANCode", width: 20 },
      { header: "Purchase Price", key: "purchasePrice", width: 20 },
      { header: "Product Code", key: "productCode", width: 20 },
      { header: "Product Tax", key: "productTax", width: 20 },
      { header: "Tax Type", key: "taxIncExc", width: 20 },
      { header: "Product Hsn Code", key: "productHsnCode", width: 20 },
      { header: "Product Images", key: "productImageArray", width: 20 },
      { header: "Product Description", key: "productDescription", width: 20 },
    ];

    //Add Header Row
    const headerRow = worksheet.getRow(1);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        bgColor: { argb: "ef4667" },
        fgColor: { argb: "ef4667" },
      };

      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
        bgColor: { argb: "ef4667" },
      };
    });

    worksheet.mergeCells("I1:L1");
    worksheet.getCell("L1").value = "Variant";
    worksheet.getCell("L1").alignment = {
      vertical: "center",
      horizontal: "center",
    };
    Array.from({
      length: 8,
      0: "A",
      1: "B",
      2: "C",
      3: "D",
      4: "E",
      5: "F",
      6: "G",
      7: "H",
    }).forEach((value, index) => {
      worksheet.mergeCells(`${value}1:${value}2`);
      worksheet.getCell(`${value}1`).alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    });

    Array.from({
      length: 9,
      0: "M",
      1: "N",
      2: "O",
      3: "P",
      4: "Q",
      5: "R",
      6: "S",
      7: "T",
      8: "U",
    }).forEach((value, index) => {
      worksheet.mergeCells(`${value}1:${value}2`);
      worksheet.getCell(`${value}1`).alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    });

    worksheet.getCell("I2").value = "Color";
    worksheet.getCell("I2").style.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ef4667" },
    };
    worksheet.getCell("J2").value = "Size";
    worksheet.getCell("J2").style.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ef4667" },
    };
    worksheet.getCell("K2").value = "Measurement Value";
    worksheet.getCell("K2").style.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ef4667" },
    };
    worksheet.getCell("L2").value = "Measurement Unit";
    worksheet.getCell("L2").style.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ef4667" },
    };

    worksheet.getRow(1).font = {
      family: 4,
      size: 16,
      color: { argb: "FFFFFF" },
    };
    worksheet.getRow(2).font = {
      family: 4,
      size: 16,
      color: { argb: "FFFFFF" },
    };
    worksheet.getRow(2).alignment = {
      vertical: "middle",
      horizontal: "center",
    };

    worksheet.dataValidations.add("A3:A9999", {
      type: "whole",
      operator: "between",
      allowBlank: false,
      formulae: [1, 9999],
      showErrorMessage: true,
      errorStyle: "error",
      error:
        "The value must be between 1 to 9999. For variant products, the serial number value should be same.",
    });

    worksheet.getCell("C3:C9999").note =
      "For variant products, the category should be same.";
    worksheet.getCell("D3:D9999").note =
      "For variant products, the sub category should be same.";
    worksheet.getCell("E3:E9999").note =
      "For variant products, the product brand should be same.";
    worksheet.getCell("F3:F9999").note =
      "For variant products, the product Name should be same.";
    worksheet.getCell("I3").note =
      "Choose the color using the fill option. Color value is only considered for variant products.";
    worksheet.getCell("J3").note =
      "Size value is only considered for variant products.";
    worksheet.dataValidations.add("L3:L9999", {
      type: "list",
      allowBlank: false,
      formulae: [`"${UNIT.toString()}"`],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Select the unit from the list",
    });

    worksheet.dataValidations.add("Q3:Q9999", {
      type: "list",
      allowBlank: false,
      formulae: [`"${taxNameArray.toString()}"`],
      showErrorMessage: true,
      errorStyle: "error",
      error:
        "Entered tax name is not available,please add the tax in taxmaster and download the latest excel template for products upload.",
    });
    worksheet.dataValidations.add("R3:R9999", {
      type: "list",
      allowBlank: false,
      formulae: ['"inclusive,exclusive"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "The select any one tax type",
    });

    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fs.saveAs(blob, "productUploadTemplate.xlsx");
    });
  };
  useEffect(() => {
    const getShopDetailsApi = async (id) => {
      var shopDetailsRes = await fetch(
        `${config.newApiGateway}/customer/createCustomerandgetCustomer`,
        {
          method: "POST",
          body: JSON.stringify({
            shopId: id,
            action: "getShopDetails",
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      shopDetailsRes = await shopDetailsRes.json();
      // setUpdatedShop(shopDetailsRes);
      setUpdatedShop(shopDetailsRes.Items[0]);
    };
    if (shopDetails.shopId) {
      getShopDetailsApi(shopDetails.shopId);
    }
  }, [shopDetails]);

  const headerKeys = {
    A: "serialNo",
    B: "group",
    C: "category",
    D: "subCategory",
    E: "productBrand",
    F: "productName",
    G: "productMrp",
    H: "productPrice",
    I: "color",
    J: "size",
    K: "measurmentValue",
    L: "measurmentUnit",
    M: "inventoryQty",
    N: "productEANCode",
    O: "purchasePrice",
    P: "productCode",
    Q: "taxId",
    R: "taxIncExc",
    S: "productHsnCode",
    T: "productImageArray",
    U: "productDescription",
  };

  const getColumnValues = (worksheet) => {
    return new Promise((resolve, reject) => {
      const productDefaultData = {
        productId: uuidv4(),
        addedDate: new Date().toISOString().substr(0, 10),
        shopId: shopDetails.shopId,
        status: "live",
        group: "",
        category: "",
        subCategory: "",
        productBrand: "",
        productName: "",
        productMrp: "",
        productPrice: "TBD",
        unitOfMeasurment: "",
        productEANCode: "TBD",
        purchasePrice: "",
        inventoryQty: 0,
        productCode: "",
        versionId: "1",
        latest: "true",
        lowStockAlert: 5,
        productImageArray: [],
        productDescription: "",
        productType: "product",
        productTax: "",
        productTaxType: "",
        productHsnCode: "",
        taxIncExc: "",
        taxId: "",
        ...(["Outlet", "Employee"].includes(shopDetails.userType) && {
          shopId: shopDetails.shopId,
          parentShopId: shopDetails.ownerShopId,
        }),
      };
      const values = {};

      Object.keys(headerKeys).forEach((header) => {
        if (worksheet.getColumn(header).values) {
          worksheet
            .getColumn(header)
            .eachCell({ includeEmpty: true }, (cell, index) => {
              let fillColor = "";
              let productImageArray = [];
              if (header === "I") {
                fillColor = cell.style?.fill?.fgColor?.argb
                  ? `#${cell.style.fill.fgColor?.argb?.slice(2)}`
                  : "";
              }
              if (header === "T") {
                productImageArray = cell.value?.text?.split?.(",");
              }

              values[index] = {
                ...productDefaultData,
                ...values[index],
                productId: uuidv4(),
                [headerKeys[header]]:
                  header === "I"
                    ? fillColor
                    : header === "T"
                    ? productImageArray
                    : cell.value
                    ? String(cell.value).trim()
                    : "",
              };
            });
        } else {
          reject("In valid column name");
        }

        resolve(values);
      });
    });
  };

  const getExcelData = async (e) => {
    let fileObj = e.target.files[0];

    const reader = new FileReader();

    reader.onload = function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = new Workbook();

      workbook.xlsx
        .load(data)
        .then(() => {
          // Assuming data is in the first sheet
          const worksheet = workbook.getWorksheet("Add Product Excel");

          getColumnValues(worksheet)
            .then((values) => {
              const data = values;
              delete data[1];
              delete data[2];
              const variantProducts = [];
              const individualProduct = [];
              const products = Object.values(data);
              const groupBySerial = groupBy(products, "serialNo");
              const viewData = [];
              console.log("groupBySerial", Object.keys(groupBySerial));
              Object.keys(groupBySerial)
                .filter((i) => i !== "undefined" && i !== "null" && i !== "")
                .forEach((i) => {
                  const items = groupBySerial[i];
                  if (items.length > 1) {
                    const parentProductId = uuidv4();
                    viewData.push({
                      ...items[0],
                      parentProductId,
                      variant: true,
                      variantData: items.map((j) => ({
                        ...j,
                        parentProductId,
                      })),
                    });
                    items.forEach((item) => {
                      variantProducts.push({
                        ...item,
                        parentProductId,
                        variant: true,
                      });
                    });
                  } else if (items?.[0]?.size || items?.[0]?.color) {
                    variantProducts.push({
                      ...items[0],
                      parentProductId: uuidv4(),
                      variant: true,
                      key: items[0]?.productId,
                    });
                    viewData.push(items[0]);
                  } else {
                    viewData.push({
                      ...items[0],
                      key: uuidv4(),
                    });
                    individualProduct.push(items[0]);
                  }
                });
              console.log("viewData", viewData);
              setTableViewData(viewData);
            })
            .catch((error) => {
              console.error("Error reading the Excel:", error.message);
            });
          // const cell = worksheet.getCell("A1");
          // const cell2 = worksheet.getCell("B1");
          // const fillColor = cell.style.fill ? cell.style.fill.fgColor : null;
          // const fillColor2 = cell2.style.fill ? cell2.style.fill.fgColor : null;
        })
        .catch((error) => {
          console.error("Error reading the Excel file:", error.message);
        });
    };

    reader.readAsArrayBuffer(fileObj);
    // ExcelRenderer(fileObj, (err, data) => {
    //   console.log("exceldata", data);
    //   if (err) {
    //     console.log("Error", err);
    //   } else {
    //     if (rowTemplate.length !== data.rows[0].length) {
    //       errorPopUp();
    //       console.log("erorin1");
    //       return;
    //     }
    //     for (var i = 0; i < data.rows[0].length; i++) {
    //       if (data.rows[0].includes(rowTemplate[i])) {
    //         continue;
    //       }
    //       console.log("erorin2");

    //       errorPopUp();
    //       return;
    //     }
    //     let arr = [];
    //     for (var i = 1; i < data.rows.length; i++) {
    //       let rowArr = data.rows[i];
    //       let headingArr = data.rows[0];
    //       let count = 0;
    //       let mValue = "";
    //       let mUnit = "";
    //       if (rowArr.length <= 0) continue;
    //       let obj = {
    //         productId: uuidv4(),
    //         addedDate: new Date().toISOString().substr(0, 10),
    //         shopId: shopDetails.shopId,
    //         status: "live",
    //         group: "",
    //         category: "",
    //         subCategory: "",
    //         productBrand: "",
    //         productName: "",
    //         productMrp: "",
    //         productPrice: "TBD",
    //         unitOfMeasurment: "",
    //         productEANCode: "TBD",
    //         purchasePrice: "",
    //         inventoryQty: 0,
    //         productCode: "",
    //         versionId: "1",
    //         latest: "true",
    //         lowStockAlert: 5,
    //         productImageArray: [],
    //         productType: "product",
    //         productTax: "",
    //         productTaxType: "",
    //         productHsnCode: "",
    //         taxIncExc: "",
    //         mUnit: "",
    //         mValue: "",
    //         taxId: "",
    //         ...(["Outlet", "Employee"].includes(shopDetails.userType) && {
    //           shopId: shopDetails.shopId,
    //           parentShopId: shopDetails.ownerShopId,
    //         }),
    //       };

    //       rowArr.map((data, index) => {
    //         if (count !== index) {
    //           for (var i = count; i < index; i++) {
    //             if (headingArr[i] === "category") {
    //               obj = {
    //                 ...obj,
    //                 category: "OTHERS",
    //               };
    //             }
    //             if (headingArr[i] === "group") {
    //               obj = {
    //                 ...obj,
    //                 group: "Others",
    //               };
    //             }
    //             if (headingArr[i] === "productPrice") {
    //               obj = {
    //                 ...obj,
    //                 productPrice: "TBD",
    //               };
    //             }
    //             if (headingArr[i] === "productImageArray") {
    //               obj = {
    //                 ...obj,
    //                 productImageArray: [],
    //               };
    //             }
    //             if (
    //               headingArr[i] === "measurement Value" ||
    //               headingArr[i] === "measurement Unit"
    //             ) {
    //               if (headingArr[i] === "measurement Value") {
    //                 mUnit = data;
    //               }
    //               if (headingArr[i] === "measurement Unit") {
    //                 mValue = data;
    //               }
    //               console.log("rowArr111", rowArr);
    //               obj = {
    //                 ...obj,
    //                 mUnit: mUnit,
    //                 mValue: mValue,
    //                 unitOfMeasurment: rowArr[8]
    //                   ? rowArr[8] + "-" + rowArr[9]
    //                   : "Others",
    //               };
    //             }

    //             if (headingArr[i] === "subCategory") {
    //               obj = {
    //                 ...obj,
    //                 subCategory: "others",
    //               };
    //             }
    //             if (headingArr[i] === "productEANCode") {
    //               obj = {
    //                 ...obj,
    //                 productEANCode: "TBD",
    //               };
    //             }
    //           }
    //           count = index;
    //         }
    //         if (count === index) {
    //           if (headingArr[count] === "measurement Value") {
    //             mValue = data.toString();
    //             count++;
    //             return;
    //           } else if (headingArr[count] === "measurement Unit") {
    //             mUnit = data;
    //             count++;
    //             return;
    //           } else if (headingArr[count] === "productImageArray") {
    //             var arr = data.split(",");
    //             obj = {
    //               ...obj,
    //               [headingArr[count]]: arr,
    //             };
    //           } else if (headingArr[count] === "productTax") {
    //             obj = {
    //               ...obj,
    //               [headingArr[count]]: data,
    //             };
    //           } else if (headingArr[count] == "taxIncExc") {
    //             obj = {
    //               ...obj,
    //               [headingArr[count]]: data,
    //             };
    //           } else
    //             obj = {
    //               ...obj,
    //               [headingArr[count]]: data.toString(),
    //             };
    //           if (count === rowArr.length - 1) {
    //             if (mValue !== "" && mUnit !== "") {
    //               obj = {
    //                 ...obj,

    //                 unitOfMeasurment: rowArr[7]
    //                   ? rowArr[7] + " " + rowArr[8]
    //                   : "",
    //               };
    //             } else {
    //               obj = {
    //                 ...obj,
    //                 mUnit: mUnit,
    //                 mValue: mValue,
    //                 unitOfMeasurment: "",
    //               };
    //             }
    //           }
    //         }
    //         count++;
    //       });
    //       if (obj.productTax && obj.taxIncExc == "Inclusive/Exclusive") {
    //         // setErrorInData(true);
    //         dataError = true;
    //       }
    //       // if (obj.category) {
    //       // }
    //       arr.push(obj);
    //     }
    //     if (dataError) {
    //       setDataArray([]);
    //       // setErrorInData(false);
    //       dataError = false;
    //       // e.target.value = ''
    //       return alert(
    //         `Tax inclusive/exclusive field cannot be empty if tax is selected, please choose any one tax type and upload again`
    //       );
    //     }
    //     if (arr.length > 0) {
    //       arr.map((data) => {
    //         if (data.category) {
    //           data.category = data.category.toUpperCase();
    //         }
    //         if (data.subCategory) {
    //           data.subCategory = data.subCategory;
    //         }

    //         updatedShop.taxMaster?.map((value) => {
    //           if (data.productTax == value.taxName) {
    //             data.taxId = value.taxId;
    //           }
    //         });
    //       });
    //     }
    //     setDataArray(arr);
    //   }
    // });
  };
  // useEffect(() => {
  //   console.log("updatedShopupdatedShop", updatedShop);
  // }, [updatedShop]);

  const taxableValueFunc = useCallback(
    (productPrice = 0, productTax = 0, count, taxIncExc = "", isTax) => {
      let result = 0;
      if (taxIncExc === "inclusive") {
        result =
          (productPrice / (100 + parseInt(productTax || 0))) *
          parseFloat(count || 0) *
          100;
      } else if (taxIncExc === "exclusive") {
        result = productPrice * parseFloat(count || 0);
      } else {
        result = productPrice * count;
      }

      console.log("result1111", result);
      return result;
    },
    []
  );

  const taxTypeFunc = useCallback(
    (taxableValue, seletedTax, isTax) => {
      const customTaxValue = {};

      seletedTax?.taxType?.forEach((tax) => {
        const taxTypeName =
          customTaxType.find((customTax) => customTax.taxId === tax)?.taxName ||
          tax;
        customTaxValue[taxTypeName] =
          (customTaxValue[taxTypeName] || 0) +
          parseFloat(
            taxableValue * (parseFloat(seletedTax[taxTypeName] || 0) / 100)
          );
      });

      const sumOfTax = Object.values(customTaxValue).reduce(
        (acc, cur) => acc + cur,
        0
      );
      const itemTotal = parseFloat(taxableValue) + sumOfTax;
      return {
        ...customTaxValue,
        taxType: Object.keys(customTaxValue),
        itemTotal,
        taxableValue,
        totalBeforeTax: taxableValue,
      };
    },
    [customTaxType]
  );

  const getTaxableValueAndTaxs = useCallback(
    (product, price = 0, quantity = 0) => {
      let taxableValue = 0;
      let totalTaxPercentage = 0;
      let taxs = {};
      let newProduct = {};
      let itemTotal = 0;

      if (
        product.taxId &&
        product.taxId !== "Select Tax" &&
        product.taxIncExc !== "Inclusive/Exclusive"
      ) {
        let selectedTax = taxMaster.find(
          (item) => item.taxName === product.taxId
        );
        totalTaxPercentage = selectedTax?.taxType?.reduce((acc, curr) => {
          const taxTypeName =
            customTaxType.find((customTax) => customTax.taxId === curr)
              ?.taxName || curr;
          return acc + parseFloat(selectedTax[taxTypeName] || 0);
        }, 0);
        taxableValue = taxableValueFunc(
          price,
          totalTaxPercentage,
          quantity,
          product.taxIncExc
        );
        taxs = taxTypeFunc(taxableValue, selectedTax);
        console.log("taxs111", taxs);
        itemTotal = taxs.itemTotal;
      } else {
        itemTotal = price * parseFloat(quantity);
      }

      let discount = 0;
      newProduct = {
        ...product,
        ...taxs,
        count: quantity,
        productPrice: price,
        taxType: taxs.taxType ? taxs.taxType : [],
        totalTax: totalTaxPercentage,
        itemTotal:
          product.discountType === "flat"
            ? itemTotal - discount * quantity
            : itemTotal - discount,
      };
      return newProduct;
    },
    [taxMaster, taxableValueFunc, taxTypeFunc, customTaxType]
  );

  const excelValidator = (productItem, reject, index, variantIndex) => {
    let variantText = "";
    if (variantIndex) {
      variantText = `in Variant ${variantIndex + 1}`;
    }
    if (
      !(
        productItem.size ||
        productItem.color ||
        (productItem.measurmentValue && productItem.measurmentUnit)
      ) &&
      variantText
    ) {
      reject(
        `Please select size or color or unit of measurment for Item no ${
          index + 1
        } ${variantText}`
      );
    }
    if (!productItem.group) {
      reject(`Group cannot be empty for Item no ${index + 1} ${variantText}`);
    }
    if (!productItem.category) {
      reject(
        `Category cannot be empty for Item no ${index + 1} ${variantText}`
      );
    }
    if (!productItem.subCategory) {
      reject(
        `Sub Category cannot be empty for Item no ${index + 1} ${variantText}`
      );
    }
    if (!productItem.productName) {
      reject(
        `Product name cannot be empty for Item no ${index + 1} ${variantText}`
      );
    }
    if (productItem.productMrp) {
      if (!isNumeric(productItem.productMrp)) {
        reject(
          `Product Mrp must be a number for Item no ${index + 1} ${variantText}`
        );
      }

      if (
        parseFloat(productItem.productMrp) <
        parseFloat(productItem.productPrice)
      ) {
        reject(
          "Selling Price cannot be greater than Mrp for Item Number(s):" +
            productItem.serialNo
        );
      }
    }
    if (!productItem.productPrice) {
      reject(
        `Selling Price cannot be empty for Item no ${index + 1} ${variantText}`
      );
    }
    if (!isNumeric(productItem.productPrice)) {
      reject(
        `Selling Price must be a number for Item no ${index + 1} ${variantText}`
      );
    }
    if (!productItem.measurmentValue && productItem.measurmentUnit) {
      reject(
        `Measurement Value cannot be empty for Item no ${
          index + 1
        } ${variantText}`
      );
    }
    if (productItem.measurmentValue) {
      if (!isNumeric(productItem.measurmentValue)) {
        reject(
          `Measurement Value must be a number for Item no ${
            index + 1
          } ${variantText}`
        );
      }
    }
    if (productItem.measurmentValue && !productItem.measurmentUnit) {
      reject(
        `Measurement Unit cannot be empty for Item no ${
          index + 1
        } ${variantText}`
      );
    }
    if (!productItem.inventoryQty) {
      reject(
        `Inventory Quantity cannot be empty for Item no ${
          index + 1
        } ${variantText}`
      );
    }
    if (productItem.inventoryQty) {
      if (!isNumeric(productItem.inventoryQty)) {
        reject(`Inventory Quantity must be a number for Item no ${index + 1}`);
      }
    }
    if (productItem.purchasePrice) {
      if (!isNumeric(productItem.purchasePrice)) {
        reject(`Purchase Price must be a number for Item no ${index + 1}`);
      }
    }
    if (!productItem.taxId && productItem.taxIncExc) {
      reject(`Tax cannot be empty for Item no ${index + 1}`);
    }
    if (!productItem.taxIncExc && productItem.taxId) {
      reject(
        `Tax inclusive/exclusive cannot be empty for Item no ${index + 1}`
      );
    }
    if (productItem.taxIncExc && productItem.taxId && productItem.productMrp) {
      const productData = getTaxableValueAndTaxs(
        productItem,
        productItem.productPrice,
        1
      );
      if (productItem.productMrp < productData.itemTotal) {
        reject(
          `Selling price exceeding the MRP after applying tax for Item Number(s):${
            index + 1
          } ${variantText}`
        );
      }
    }
  };

  const toTernary = (value) => {
    return value ? value : "";
  };
  const verifyListAndUpload = () => {
    new Promise((resolve, reject) => {
      tableViewData.forEach((productItem, index, arr) => {
        excelValidator(productItem, reject, index);
        if (productItem.variant) {
          const variant = {};
          productItem.variantData.forEach((i, variantIndex) => {
            const units = `${toTernary(i.measurmentValue)}${toTernary(
              i.measurmentUnit
            )}${toTernary(i.size)}${toTernary(i.color)}`;
            if (!variant.hasOwnProperty(units)) {
              variant[units] = i.productId;
              excelValidator(i, reject, index, variantIndex);
            } else {
              reject(
                `Variant already exist for Item no ${index + 1} in Variant ${
                  variantIndex + 1
                }`
              );
            }
          });
        }
        if (tableViewData.length - 1 === index) {
          resolve(arr);
        }
      });
    })
      .then((res) => {
        console.log("res2222", res);
        const updatedTheResult = [];
        res.forEach((i) => {
          const tax = taxMaster.find((item) => item.taxName === i.taxId);
          if (i.variant) {
            const parentProductId = uuidv4();
            i.variantData.forEach((j) => {
              const tax = taxMaster.find((item) => item.taxName === j.taxId);
              let type = [];
              const unitOfMeasurment =
                toTernary(j.measurmentValue) +
                " " +
                toTernary(j.measurmentUnit);
              if (j.size && !type.includes("size")) {
                type.push("size");
              }
              if (j.color && !type.includes("color")) {
                type.push("color");
              }
              if (
                j.measurmentValue &&
                j.measurmentUnit &&
                !type.includes("UOM")
              ) {
                type.push("UOM");
              }
              let key = [];

              if (j.size) {
                key.push(j.size);
              }
              if (j.color) {
                key.push(j.color);
              }
              if (j.measurmentValue && j.measurmentUnit) {
                key.push(unitOfMeasurment);
              }

              const updateProduct = {
                ...j,
                category: i.category ? i.category.toUpperCase() : "",
                subCategory: i.subCategory ? i.subCategory.toLowerCase() : "",
                productImageArray: j.productImageArray
                  ? j.productImageArray
                  : [],
                parentProductId: parentProductId,
                key: key.join("-"),
                productName: i.productName,
                productBrand: i.productBrand ? i.productBrand : "",
                type: type.join("-"),
                taxId: tax?.taxId ? tax?.taxId : "",
                taxIncExc: j?.taxIncExc ? j?.taxIncExc : "",
                inventoryQty: j.inventoryQty ? parseFloat(j.inventoryQty) : 0,
                unitOfMeasurment: unitOfMeasurment.trim(),
              };
              delete updateProduct.variant;
              delete updateProduct.variantData;
              delete updateProduct.measurmentValue;
              delete updateProduct.measurmentUnit;
              delete updateProduct.serialNo;
              console.log("updateProduct11", updateProduct);
              updatedTheResult.push(updateProduct);
            });
          } else {
            const unitOfMeasurment =
              toTernary(i.measurmentValue) + " " + toTernary(i.measurmentUnit);
            const updateProduct = {
              ...i,
              category: i.category ? i.category.toUpperCase() : "",
              subCategory: i.subCategory ? i.subCategory.toLowerCase() : "",
              productImageArray: i.productImageArray ? i.productImageArray : [],
              taxId: tax?.taxId ? tax?.taxId : "",
              taxIncExc: i?.taxIncExc ? i?.taxIncExc : "",
              inventoryQty: i.inventoryQty ? parseFloat(i.inventoryQty) : 0,
              unitOfMeasurment: unitOfMeasurment.trim(),
            };
            updatedTheResult.push(updateProduct);
          }
        });

        fetch(
          `${config.newApiGateway}/products/dashboard-products-allproducts`,
          {
            method: "POST",
            body: JSON.stringify({
              type: "productBulkUpload",
              productList: updatedTheResult,
            }),
            headers: {
              "x-api-key": `${config.newApiKey}`,
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then((data) => {
            message.success("Product added successfully");
            const tempCategory = { ...data.categoryList };
            dispatch({
              type: "SET_SHOP_PROFILE_CATEGORY",
              payload: tempCategory,
            });
            setDataArray([]);
            navigate("/dashboard/shop-items");
          })
          .catch((err) => {
            console.log("err", err);
            message.error("failed, try again");
          });
      })
      .catch((err) => {
        console.log("err", err);
        message.error(err);
      });
  };
  const uploadProduct = async () => {
    let error = false;
    const tempDataArray = structuredClone(dataArray);

    try {
      tempDataArray.map((i, index) => {
        const ind = index + 1;
        if (!i.productName) {
          error = true;
          alert("Product name cannot be empty for Item Number(s):" + ind);
        } else if (!i.productPrice) {
          error = true;
          alert("Selling Price cannot be empty for Item Number(s):" + ind);
        } else if (!/^\d+$/.test(i.productPrice)) {
          error = true;
          alert("Selling Price must be a number for Item Number(s):" + ind);
        } else if (i.productMrp) {
          if (!/^\d+$/.test(i.productMrp)) {
            error = true;
            alert("Mrp must be a number for Item Number(s):" + ind);
          }
          if (parseFloat(i.productMrp) < parseFloat(i.productPrice)) {
            error = true;

            alert(
              "Selling Price cannot be greater than Mrp for Item Number(s):" +
                ind
            );
          }
        } else if (i.productPrice) {
          if (!/^\d+$/.test(i.productPrice)) {
            error = true;
            alert("Selling Price must be a number for Item Number(s):" + ind);
          }
        } else if (!i.inventoryQty) {
          error = true;
          alert("Inventory quantity cannot be empty for Item Number(s):" + ind);
        } else if (!i.category) {
          error = true;

          alert("Category mrp cannot be empty for Item Number(s):" + ind);
        } else if (!i.subCategory) {
          error = true;
          alert("Sub category mrp cannot be empty for Item Number(s):" + ind);
        } else if (i.unitOfMeasurment) {
          if (!/^\d+$/.test(i.unitOfMeasurment)) {
            error = true;
            alert(
              "Unit Of Measurment must be a number for Item Number(s):" + ind
            );
          }
        }
        if (!/^\d+(\.\d+)?$/.test(i.inventoryQty)) {
          error = true;

          alert(
            "Inventory quantity must be a number for Item Number(s):" + ind
          );
        }
        if (i.taxId && !i.taxIncExc) {
          error = true;
          alert("Select the tax type for Item Number(s):" + ind);
        }
        if (!i.taxId && i.taxIncExc) {
          error = true;
          alert("Select the tax for Item Number(s):" + ind);
        }
        if (!i.mUnit && i.mValue) {
          error = true;
          alert("Enter the measurement value for Item Number(s):" + ind);
        }
        if (i.mUnit && !i.mValue) {
          error = true;
          alert("Enter the measurement unit for Item Number(s):" + ind);
        }
        if (error) {
          throw new Error("error");
        }
      });
    } catch (err) {}

    if (error) return;

    const dataArrayTemp = dataArray.map((i) => {
      return {
        ...i,
        inventoryQty: i.inventoryQty ? parseFloat(i.inventoryQty) : 0,
      };
    });
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify({
          type: "productBulkUpload",
          productList: dataArrayTemp,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(([data]) => {
        alert("Product added successfully");
        const tempCategory = { ...data.categoryList };
        dispatch({
          type: "SET_SHOP_PROFILE_CATEGORY",
          payload: tempCategory,
        });
        setDataArray([]);
        navigate("/dashboard/shop-items");
      })
      .catch((err) => {
        console.log("err", err);
        alert("failed, try again");
      });
  };

  const errorPopUp = () => {
    alert(
      "Invalid Excel Sheet, Please Download the Excel Template given in this page add your products and upload again."
    );
    setDataArray([]);
    ref.current.value = "";
  };

  const productTableColumns = [
    {
      title: "S.No",
      fixed: "left",
      width: 50,
      render: (data) => {
        return <div>{data.serialNo}</div>;
      },
    },
    {
      title: "Group",
      dataIndex: "group",
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Sub Category",
      dataIndex: "subCategory",
    },
    {
      title: "Product Brand",
      dataIndex: "productBrand",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: `MRP(${country.CurrencySymbol})`,
      render: (data) => {
        return <div>{data.variant ? "-" : data.productMrp}</div>;
      },
    },
    {
      title: `Selling Price(${country.CurrencySymbol})`,
      render: (data) => {
        return <div>{data.variant ? "-" : data.productPrice}</div>;
      },
    },
    {
      title: "Measurement",
      render: (rowData) => {
        return (
          <span>
            {rowData.variant
              ? "-"
              : (rowData.measurmentValue ? rowData.measurmentValue : "-") +
                " " +
                (rowData.measurmentUnit ? rowData.measurmentUnit : "-")}
          </span>
        );
      },
    },
    {
      title: "Inventory Quantity",
      render: (data) => {
        return <div>{data.variant ? "-" : data.inventoryQty}</div>;
      },
    },
    {
      title: "Product EAN Code",
      render: (data) => {
        return <div>{data.variant ? "-" : data.productEANCode}</div>;
      },
    },
    {
      title: `Purchase Price(${country.CurrencySymbol})`,
      render: (data) => {
        return <div>{data.variant ? "-" : data.purchasePrice}</div>;
      },
    },
    {
      title: "Product Code",
      render: (data) => {
        return <div>{data.variant ? "-" : data.productCode}</div>;
      },
    },
    {
      title: "Product Image",
      render: (data) => {
        return (
          <div>{data.variant ? "-" : data.productImageArray?.toString()}</div>
        );
      },
    },
    {
      title: "Product Tax",
      render: (data) => {
        return <div>{data.variant ? "-" : data.taxId}</div>;
      },
    },
    {
      title: "tax Inc/Exc",
      render: (data) => {
        return <div>{data.variant ? "-" : data.taxIncExc}</div>;
      },
    },
  ];
  return (
    <>
      <Card
        bodyStyle={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
        style={{
          marginBottom: 20,
        }}
      >
        <>
          <input
            style={{
              width: "200px",
            }}
            ref={ref}
            id="excelInput"
            className="fileInput"
            type="file"
            accept="application/vnd.ms-excel,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={(e) => {
              getExcelData(e);
            }}
            onClick={() => (ref.current.value = "")}
          />
          <AntdButton
            disabled={tableViewData.length >= 1 ? false : true}
            type="dashed"
            onClick={() => {
              verifyListAndUpload();
            }}
          >
            Upload
          </AntdButton>
          <AntdButton
            onClick={() => {
              generateExcel();
            }}
            type="primary"
            style={{
              marginLeft: 24,
            }}
          >
            Download Template
          </AntdButton>
        </>
      </Card>
      <CustomTable
        title={"Excel Upload"}
        columns={productTableColumns}
        data={tableViewData}
        expandable={{
          expandedRowRender,
          rowExpandable: (record) => record.variant,
        }}
        rowKey={"productId"}
      />
      <div>
        {/* <AntdButton
          style={{
            marginLeft: "20px",
          }}
          variant="outline-danger"
          onClick={() => {
            generateExcel();
          }}
        >
          Download Template
        </AntdButton> */}
        {/* <CSVLink data={csvData}>Download me</CSVLink>; */}
        {/* <input
          ref={ref}
          id="excelInput"
          className="fileInput"
          style={{
            marginLeft: "20px",
          }}
          type="file"
          accept="application/vnd.ms-excel,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          onChange={(e) => {
            getExcelData(e);
          }}
          onClick={() => (ref.current.value = "")}
        /> */}
        {/* <Button
          disabled={dataArray.length >= 1 ? false : true}
          variant="outline-danger"
          onClick={() => {
            uploadProduct();
          }}
        >
          Upload
        </Button> */}
        {/* <button onClick={() => generateExcel()}>generate</button> */}
        {/* <div>
          <MaterialTable
            columns={
              [
              {
                title: "Group",
                field: "group",
              },
              {
                title: "Category",
                field: "category",
                // render: (dataArray) => {
                //   return <div>{dataArray.category.toUpperCase()}</div>;
                // },
              },
              {
                title: "Sub Category",
                field: "subCategory",
              },
              {
                title: "Product Brand",
                field: "productBrand",
              },
              {
                title: "Product Name",
                field: "productName",
              },
              {
                title: `MRP(${country.CurrencySymbol})`,
                field: "productMrp",
              },
              {
                title: `Selling Price(${country.CurrencySymbol})`,
                field: "productPrice",
              },
              {
                title: "Measurement",
                field: "unitOfMeasurment",
              },
              {
                title: "Inventory Quantity",
                field: "inventoryQty",
              },
              {
                title: "Product EAN Code",
                field: "productEANCode",
              },
              {
                title: `Purchase Price(${country.CurrencySymbol})`,
                field: "purchasePrice",
              },
              {
                title: "Product Code",
                field: "productCode",
              },
              {
                title: "Product Image",
                field: "productImageArray",
              },
              {
                title: "Product Tax",
                field: "productTax",
              },
              {
                title: "tax Inc/Exc",
                field: "taxIncExc",
              },
            ]}
            title="Products"
            options={{
              search: false,
            }}
            data={dataArray}
            icons={tableIcons}
            components={{
              Pagination: PatchedPagination,
            }}
            style={{
              margin: "20px",
            }}
          />
        </div> */}
      </div>
    </>
  );
};

export default ProductExcelUpload;
